import { render, staticRenderFns } from "./InformationEdit.vue?vue&type=template&id=96851518&scoped=true"
import script from "./InformationEdit.vue?vue&type=script&lang=js"
export * from "./InformationEdit.vue?vue&type=script&lang=js"
import style0 from "./InformationEdit.vue?vue&type=style&index=0&id=96851518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96851518",
  null
  
)

export default component.exports